import React from 'react';
import { Select, SelectOption } from 'ui';
import { useIntl } from 'react-intl';
import useQueryApiClient from 'utils/useQueryApiClient';
import { Validations } from 'interfaces';
import { FormItemLayout } from 'antd/es/form/Form';
import { BaseOptionType, DefaultOptionType } from 'antd/es/select';

interface EnumProps {
  id: number;
  value: string;
}

interface EnumSelectProps extends Validations {
  name?: (string | number)[] | string | number;
  mode?: 'multiple' | 'tags';
  noStyle?: boolean;
  label?: string;
  disabled?: boolean;
  code: string;
  limited?: string[];
  layout?: FormItemLayout;
  value?: string | number | string[];
  onChange?: (
    value: any,
    option?:
      | DefaultOptionType
      | BaseOptionType
      | (DefaultOptionType | BaseOptionType)[]
  ) => void;
  allowClear?: boolean;
  style?: React.CSSProperties;
}

const EnumSelect = ({
  name,
  mode,
  validations,
  noStyle,
  label,
  disabled,
  code,
  limited,
  layout,
  value,
  onChange,
  allowClear,
  style,
}: EnumSelectProps) => {
  const intl = useIntl();

  const { data } = useQueryApiClient({
    request: {
      url: `api/v2/enums/${code}`,
    },
  });

  return (
    <Select
      mode={mode}
      label={label}
      name={name}
      value={value}
      validations={validations}
      noStyle={noStyle}
      disabled={disabled}
      layout={layout}
      onChange={onChange}
      allowClear={allowClear}
      style={style}
    >
      {data
        .filter((entry: EnumProps) =>
          limited?.length ? limited?.includes(entry.value) : true
        )
        .map((entry: EnumProps) => (
          <SelectOption key={entry.id} value={entry.value}>
            {intl.formatMessage({ id: 'enum.' + entry.id })}
          </SelectOption>
        ))}
    </Select>
  );
};

export default EnumSelect;
